module.exports = __webpack_public_path__ + "../resources/img/normal_process2.0161b1dd.png";